import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class ScheduleProfile {

  @JsonProperty()
  active: boolean = false;

  @JsonProperty()
  alert: boolean = false;

  @JsonProperty()
  uiShortCut: boolean = false;

  @JsonProperty()
  alertLimitOneADay: boolean = false;

  @JsonProperty()
  alertType: ScheduleProfile.ALERT_TYPE = ScheduleProfile.ALERT_TYPE.ERROR;

  @JsonProperty()
  alertExpectedExitCodes: number[] = [];

  @JsonProperty()
  alertSubject: string | undefined;

  @JsonProperty()
  alertRecipients: string[];

  @JsonProperty()
  originTitle: string | undefined;

  @JsonProperty()
  title: string | undefined;

  @JsonProperty()
  cron: string | undefined;

  @JsonProperty()
  argCmds: ScheduleProfile.ArgCmd[] = [];

  @JsonProperty()
  argSQLCmds: ScheduleProfile.ArgSQLCmd[] = [];

  @JsonProperty()
  argExtractFiles: ScheduleProfile.ArgExtractFile[] = [];

  @JsonProperty()
  argUpdateProps: ScheduleProfile.ArgUpdateProps[] = [];

  @JsonProperty()
  argLogsAnalyses: ScheduleProfile.ArgLogsAnalyze[] = [];

  @JsonProperty()
  argDBSyncs: ScheduleProfile.ArgDBSync[] = [];

}

export module ScheduleProfile {
  export enum ALERT_TYPE {
    ERROR = 'ERROR',
    INFO = 'INFO'
  }

  export class ArgProfile {
    @JsonProperty()
    title: string = '-';

    @JsonProperty()
    order: number = 0;

    @JsonProperty()
    active: boolean = true;
  }

  export class ArgDB extends ArgProfile {

    @JsonProperty()
    dbDriver: string | undefined;

    @JsonProperty()
    dbUrl: string | undefined;

    @JsonProperty()
    dbUsername: string | undefined;

    @JsonProperty()
    dbPassword: string | undefined;
  }

  export class DBTableDetail extends ArgDB {

    @JsonProperty()
    tableNames: string[];

    @JsonProperty()
    dateColumn: string | undefined;

    @JsonProperty()
    customSelectWherePart: string | undefined;
  }

  export class DbDetail extends ArgDB {

    @JsonProperty()
    filters: DbFilter[];

    @JsonProperty()
    tableNames: string[];
  }

  export class DbFilter {
    @JsonProperty()
    column: string;

    @JsonProperty()
    values: string[];
  }

  export class ArgCmd extends ArgProfile {
    @JsonProperty()
    cmdLines: string[];

    @JsonProperty()
    workingDir: string | undefined;
  }

  export class ArgSQLCmd extends ArgProfile {
    @JsonProperty()
    dbDriver: string | undefined;

    @JsonProperty()
    dbUrl: string | undefined;

    @JsonProperty()
    dbUsername: string | undefined;

    @JsonProperty()
    dbPassword: string | undefined;

    @JsonProperty()
    dbQuery: string | undefined;

    @JsonProperty()
    expectedResult: string | undefined;
  }

  export class ArgExtractFile extends ArgProfile {

    @JsonProperty()
    source: string | undefined;

    @JsonProperty()
    dest: string | undefined;
  }

  export class ArgUpdateProps extends ArgProfile {

    @JsonProperty()
    source: string | undefined;
  }

  export class ArgDBSync extends ArgProfile {

    @JsonProperty()
    tablesToSync: DBTableDetail[];

    @JsonProperty()
    dayToSync: DateTime;
    dayToSyncSt: string;

    @JsonProperty()
    originDb: DbDetail = new DbDetail();

    @JsonProperty()
    destinationDbs: DbDetail[];
  }

  export class ArgLogsAnalyze extends ArgProfile {

    @JsonProperty()
    paths: string[];

    @JsonProperty()
    scanMode: LogScanMode = LogScanMode.TAIL;

    @JsonProperty()
    recursive: boolean = false;

    @JsonProperty()
    includeFileNameRegex?: string;

    @JsonProperty()
    excludeFileNameRegex?: string;

    @JsonProperty()
    encoding: string = "UTF-8";

    @JsonProperty()
    startAtEndOnFirstSeen: boolean = true;

    @JsonProperty()
    stateDir?: string;

    @JsonProperty()
    stateKey?: string;

    @JsonProperty()
    resetState: boolean = false;

    @JsonProperty()
    maxBytesPerFilePerRun: number = 5 * 1024 * 1024;

    @JsonProperty()
    maxLinesPerFilePerRun: number = 20_000;

    @JsonProperty()
    maxBytesBack: number = 5 * 1024 * 1024;

    @JsonProperty()
    cutoffMinutes?: number;

    @JsonProperty()
    timestampRegex?: string;

    @JsonProperty()
    timestampFormat?: string;

    @JsonProperty()
    mergeStackTraces: boolean = true;

    @JsonProperty()
    maxStackTraceLines: number = 50;

    @JsonProperty()
    failIfNoFiles: boolean = false;

    @JsonProperty()
    exitCodeNoFiles: number = 3;

    @JsonProperty()
    rules: LogRule[] = [];

    @JsonProperty()
    workingDir?: string;

  }


  export class LogRule {
    @JsonProperty()
    id!: string;

    @JsonProperty()
    title?: string;

    @JsonProperty()
    regex!: string;

    @JsonProperty()
    excludeRegexes?: string[];

    @JsonProperty()
    caseInsensitive: boolean = true;

    @JsonProperty()
    failOnMatch: boolean = true;

    @JsonProperty()
    exitCodeOnMatch: number = 2;

    @JsonProperty()
    minMatches: number = 1;

    @JsonProperty()
    stopOnTrigger: boolean = false;

    @JsonProperty()
    maxExamples: number = 5;

  }

  export enum LogScanMode {
    TAIL = 'TAIL',
    WINDOW = 'WINDOW'
  }

}
